import { PollyChartColors } from 'polly-qubit';

export const colorCode = [
  '#4065C5',
  '#CB4727',
  '#F19E38',
  '#8C1A94',
  '#4397C2',
  '#CC5077',
  '#76A832',
  '#449431',
  '#E184EA',
  '#3F8BFA',
  '#0000F9',
  '#D4BFD7',
  '#F18656',
  '#70FD88',
  '#FADA37',
  '#800A88',
  '#000088',
  '#A4CD46',
  '#5280B2',
  '#5DB275',
  '#596B34',
  '#CC2E3E',
  '#6EFCFE',
  '#CF7492',
  '#354E4F',
  '#83491B',
];
export const pollyDesignColorCode = [
  '#3F005A',
  '#4E146C',
  '#5D287F',
  '#6C3C91',
  '#7B50A3',
  '#8963B6',
  '#9877C8',
  '#A78BDA',
  '#B69FED',
  '#C5B3FF',
];

export const darkGrayColor = '#3A3A3A';

export const pollyDesignTextColorCode = [
  darkGrayColor,
  darkGrayColor,
  darkGrayColor,
  darkGrayColor,
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
];

export const PLOTLY_AXIS_COLOR: string = '#E6E6E6';

export const PLOTLY_LABEL_COLOR: string = '#3A3A3A';

export const PLOTLY_HOVER_BG_COLOR: string = '#ffffff';

export const PLOTLY_BASE_TRACE_COLOR: string[] = ['#9955F0', '#C7A1F7'];

export const PLOTLY_SECONDARY_TRACE_COLOR: string[] = ['#F79929', '#E4B99A'];

export const PLOTLY_COLORS: string[] = [        
  PollyChartColors.PURPLE_MINUS_20,
  PollyChartColors.ORANGE,
  PollyChartColors.PINK_MINUS_20,
  PollyChartColors.CYAN,
  PollyChartColors.RED_MINUS_40,
  PollyChartColors.BLUE_MINUS_20,
  PollyChartColors.GREEN,
  PollyChartColors.YELLOW_MINUS_20,
  PollyChartColors.BRAND_ALT_PURPLE_70,
  PollyChartColors.PURPLE_50,
  PollyChartColors.ORANGE_60,
  PollyChartColors.PINK_50,
  PollyChartColors.CYAN_60,
  PollyChartColors.RED_70,
  PollyChartColors.BLUE_60,
  PollyChartColors.GREEN_70,
  PollyChartColors.YELLOW_50,
  PollyChartColors.BRAND_ALT_PURPLE_85
];
